import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import Moment from "moment"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { getHouseholds as onGetHouseholds } from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Badge,
  Button,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap"

import Spinners from "components/Common/Spinner"

function Household() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { households, loading } = useSelector(state => state.household)

  const [isLoading, setLoading] = useState(loading)
  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title =
    "Households | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  useEffect(() => {
    if (households.length == 0) {
      dispatch(onGetHouseholds())
    }
  }, [dispatch, households])

  const handleAddClick = () => {
    navigate("/household/new")
  }

  const handleValidDate = date => {
    const date1 = Moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const Status = ({ status }) => {
    switch (status) {
      case true:
        return <Badge className="bg-success"> Active </Badge>
      case false:
        return <Badge className="bg-danger"> Inactive </Badge>
      default:
        return ""
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Month",
        accessor: "TrainingMonth",
        Cell: cellProps => {
          return (
            <>
              <Link to={"/household/" + cellProps.row.original.RowID}>
                <div className="flex-grow-1">
                  <h5 className={"text-body font-size-13 mb-0"}>
                    {cellProps.value}
                  </h5>
                </div>
              </Link>
            </>
          )
        },
      },
      {
        Header: "Training Type",
        accessor: "TrainingType",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Postcode",
        accessor: "Postcode",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Children",
        accessor: "ChildrenCount",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Disabled",
        accessor: "DisabledCount",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Other",
        accessor: "OtherCount",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Footfall",
        accessor: "FootfallCount",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Pensioners",
        accessor: "PensionerCount",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Delivery Postcode",
        accessor: "Delivery",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Status",
        accessor: "IsActive",
        Cell: cellProps => {
          return <Status status={cellProps.value} />
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedBy",
        Cell: cellProps => {
          return (
            <>
              <span className="font-size-14 mb-1">
                {cellProps.row.original.CreatedByName}
              </span>
              <p className="text-muted mb-0">
                {handleValidDate(cellProps.row.original.CreatedDate)}
              </p>
            </>
          )
        },
      },
    ],
    []
  )
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Households" breadcrumbItem="Household List" />
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={households}
                      isGlobalFilter={true}
                      isAddOption={true}
                      addOptionText="Add Household"
                      handleAddClick={handleAddClick}
                      customPageSize={10}
                      isPagination={true}
                      filterable={false}
                      iscustomPageSizeOptions={true}
                      tableClass="align-middle table-nowrap table-check"
                      theadClass="table-light"
                      pagination="pagination pagination-rounded mb-0 ms-auto"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}
Household.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Household
